import {
  Component,
  EventEmitter,
  Input,
  NgIterable,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

@Component({
  selector: 'app-crud-multi-input-select',
  templateUrl: './crud-multi-input-select.component.html',
  styleUrls: ['./crud-multi-input-select.component.sass'],
})
export class CrudMultiInputSelectComponent implements OnInit {
  @Input()
  initialNumber: number = 1;
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  value: string;
  @Input()
  typeCes?: TypeCesEnum | undefined;
  placeholder = 'Selecione uma opção';
  selects: { key: number; value: string }[] = [];
  @Output()
  onSelect: EventEmitter<any> = new EventEmitter();

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadPrints();
    this.addEventListenerToGroup();
  }

  addEventListenerToGroup() {
    this.group.get(this.config.name)?.valueChanges.subscribe((x) => {
      this.loadPrints();
    });
  }

  openSelectCrud(idx: number, print: any) {
    if (this.typeCes === TypeCesEnum.SHOW) return;

    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: this.config?.component,
      data: {
        type: TypeIndexEnum.SELECT,
        select: true,
        ...this.config.componentData,
      },
      callBack: (data: any) => {
        if (data) {
          this.changeFormItem(idx, data[this.value]);
          this.loadPrints();
        }
      },
    });
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  loadPrints() {
    this.selects = [];
    let selectsSize = this.initialNumber;
    let printsSelected = this.group.get(this.config.name)?.getRawValue();

    if (printsSelected?.length > selectsSize)
      selectsSize = printsSelected.length;

    if (printsSelected) {
      for (let i = 0; i < selectsSize; i++) {
        if (printsSelected[i])
          this.selects.push({ key: i, value: printsSelected[i] });
        else this.selects.push({ key: i, value: '' });
      }
    } else {
      for (let i = 0; i < selectsSize; i++)
        this.selects.push({ key: i, value: '' });
    }

    if (this.selects.filter((it) => it.value !== '').length === selectsSize)
      this.selects.push({ key: this.selects.length, value: '' });

    this.onSelect.emit(this.selects.filter((i) => i.value));
  }

  clear(idx: number, p: any) {
    p.value = '';
    this.removeFormItem(idx);
    this.loadPrints();
  }

  changeFormItem(idx: number, value: any) {
    let values = this.group.get(this.config.name)?.getRawValue();

    if (values[idx]) values[idx] = value;
    else values.push(value);

    this.group.get(this.config.name)?.setValue(values);
  }

  removeFormItem(idx: number) {
    let values = this.group.get(this.config.name)?.getRawValue();
    values.splice(idx, 1);
    this.group.get(this.config.name)?.setValue(values);
  }
}
